import { CommonModule } from '@angular/common';
import { BancoDeDadosComponent } from './banco-de-dados.component';
import { DropdownModule } from 'primeng/dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { BancoDeDadosService } from './banco-service/banco-de-dados.service';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';

@NgModule({

  providers: [BancoDeDadosService],
  
  imports: [
    CommonModule,
    DropdownModule,
    NgbModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    ToastModule
  ],
  declarations: [BancoDeDadosComponent]
})
export class BancoDeDadosModule { }
